import transactionService from "@/services/transaction";
import { useQuery } from "@tanstack/react-query";

type Props = {
  id: number;
};

function useGetTransaction({ id }: Props) {
  const { data, isLoading, refetch } = useQuery(["transaction"], () =>
    transactionService.getTransactionById(id)
  );

  return { data, isLoading, refetch };
}

export default useGetTransaction;
